import ErrorBoundary from './ErrorBoundary';
import FallbackAlert from './FallbackAlert';

export default ErrorBoundary;
export { FallbackAlert };
